module.exports = __webpack_public_path__ + "static/media/U_wyl.4c7867ba.svg";